import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'dashboard',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/view-price-full',
    name: 'view-price-full',
    component: () => import('./views/projects/summary-full'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        
        localStorage.removeItem('user');
        localStorage.removeItem('token');

        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/client',
    name: 'client',
    // meta: { authRequired: true },
    component: () => import('./views/account/clientscreen')
  },
  {
    path: '/recoverpwd',
    name: 'Recover Password',
    // meta: { authRequired: true },
    component: () => import('./views/account/recoverpwd')
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    meta: { authRequired: true },
    component: () => import('./views/auth/change_password')
  },
  {
    path: '/lock-screen',
    name: 'Lock-screen',
    meta: { authRequired: true },
    component: () => import('./views/account/lockscreen')
  },
  {
    path: '/confirm-mail',
    name: 'confirm-mail',
    meta: { authRequired: true },
    component: () => import('./views/account/confirm-mail')
  },
  {
    path: '/email-verification',
    name: 'email-verification',
    meta: { authRequired: true },
    component: () => import('./views/account/email-verification')
  },
  {
    path: '/two-step-verification',
    name: 'two-step-verification',
    meta: { authRequired: true },
    component: () => import('./views/account/two-step-verification')
  },

  {
    path: '/profile',
    name: 'profile',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/setting',
    name: 'setting',
    meta: { authRequired: true },
    component: () => import('./views/settings/default'),
  },
  {
    path: '/setting/contract',
    name: 'setting-contract',
    meta: { authRequired: true },
    component: () => import('./views/settings/contract/default'),
  },
  {
    path: '/setting/contract/add',
    name: 'setting-contract-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/contract/form'),
  },
  {
    path: '/setting/contract/edit/:id',
    name: 'setting-contract-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/contract/form'),
  },
  {
    path: '/setting/loan-template',
    name: 'setting-loan-template',
    meta: { authRequired: true },
    component: () => import('./views/settings/loantemplate/default'),
  },
  {
    path: '/setting/loan-template/add',
    name: 'setting-loan-template-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/loantemplate/form'),
  },
  {
    path: '/setting/loan-template/edit/:id',
    name: 'setting-loan-template-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/loantemplate/form'),
  },

  {
    path: '/setting/property/project',
    name: 'setting-project',
    meta: { authRequired: true },
    component: () => import('./views/settings/project/default'),
  },
  {
    path: '/setting/property/project/add',
    name: 'setting-project-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/project/form'),
  },
  {
    path: '/setting/property/project/edit/:id',
    name: 'setting-project-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/project/form'),
  },

  {
    path: '/setting/property/owner',
    name: 'setting-owner',
    meta: { authRequired: true },
    component: () => import('./views/settings/owner/default'),
  },
  {
    path: '/setting/property/owner/add',
    name: 'setting-owner-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/owner/form'),
  },
  {
    path: '/setting/property/owner/edit/:id',
    name: 'setting-owner-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/owner/form'),
  },
  {
    path: '/setting/incomeexpense/item',
    name: 'setting-incomeexpense-item',
    meta: { authRequired: true },
    component: () => import('./views/settings/incomeexpenseitem/default'),
  },
  {
    path: '/setting/incomeexpense/item/add',
    name: 'setting-incomeexpense-item-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/incomeexpenseitem/form'),
  },
  {
    path: '/setting/incomeexpense/item/edit/:id',
    name: 'setting-incomeexpense-item-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/incomeexpenseitem/form'),
  },
  {
    path: '/setting/accountbinding/:id',
    name: 'setting-accountbinding',
    meta: { authRequired: true },
    component: () => import('./views/settings/accountbinding/form'),
  },
  {
    path: '/setting/customer/type',
    name: 'setting-customer-type',
    meta: { authRequired: true },
    component: () => import('./views/settings/configuration/customertype/default'),
  },
  {
    path: '/setting/customer/type/add',
    name: 'setting-customer-type-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/configuration/customertype/form'),
  },
  {
    path: '/setting/customer/type/edit/:id',
    name: 'setting-customer-type-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/configuration/customertype/form'),
  },

  {
    path: '/setting/seller/type',
    name: 'setting-seller-type',
    meta: { authRequired: true },
    component: () => import('./views/settings/configuration/sellertype/default'),
  },
  {
    path: '/setting/seller/type/add',
    name: 'setting-seller-type-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/configuration/sellertype/form'),
  },
  {
    path: '/setting/customer/type/edit/:id',
    name: 'setting-seller-type-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/configuration/sellertype/form'),
  },

  {
    path: '/setting/supplier/type',
    name: 'setting-supplier-type',
    meta: { authRequired: true },
    component: () => import('./views/settings/configuration/suppliertype/default'),
  },
  {
    path: '/setting/supplier/type/add',
    name: 'setting-supplier-type-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/configuration/suppliertype/form'),
  },
  {
    path: '/setting/customer/type/edit/:id',
    name: 'setting-supplier-type-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/configuration/suppliertype/form'),
  },


  {
    path: '/setting/commission',
    name: 'setting-commission',
    meta: { authRequired: true },
    component: () => import('./views/settings/commission/default'),
  },
  {
    path: '/setting/commission/add',
    name: 'setting-commission-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/commission/form'),
  },
  {
    path: '/setting/commission/edit/:id',
    name: 'setting-commission-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/commission/form'),
  },

  {
    path: '/setting/schedule',
    name: 'setting-schedule',
    meta: { authRequired: true },
    component: () => import('./views/settings/scheduletemplate/default'),
  },
  {
    path: '/setting/schedule/add',
    name: 'setting-schedule-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/scheduletemplate/form'),
  },

  {
    path: '/setting/property/type',
    name: 'setting-property-type',
    meta: { authRequired: true },
    component: () => import('./views/settings/propertytype/default'),
  },
  {
    path: '/setting/property/property-type/add',
    name: 'setting-property-type-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/propertytype/form'),
  },
  {
    path: '/setting/property/property-type/edit/:id',
    name: 'setting-property-type-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/propertytype/form'),
  },
  
  // // ----- Need to Delete
  // {
  //   path: '/setting/pl/account',
  //   name: 'setting-pl-account',
  //   meta: { authRequired: true },
  //   component: () => import('./views/settings/account/default'),
  // },
  // {
  //   path: '/setting/pl/account/add',
  //   name: 'setting-pl-account-add',
  //   meta: { authRequired: true },
  //   component: () => import('./views/settings/account/form'),
  // },
  // {
  //   path: '/setting/pl/account/edit/:id',
  //   name: 'account-chart-edit',
  //   meta: { authRequired: true },
  //   component: () => import('./views/settings/account/form'),
  // },
  // //------

  {
    path: '/setting/property/payment/term',
    name: 'setting-property-payment-term',
    meta: { authRequired: true },
    component: () => import('./views/settings/paymentterm/default'),
  },
  {
    path: '/setting/property/payment/term/add',
    name: 'setting-property-payment-term-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/paymentterm/form'),
  },
  {
    path: '/setting/property/payment/term/edit/:id',
    name: 'setting-property-payment-term-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/paymentterm/form'),
  },

  {
    path: '/setting/company/round',
    name: 'setting-company-round',
    meta: { authRequired: true },
    component: () => import('./views/settings/company/roundingrule/default'),
  },
  {
    path: '/setting/company/round/add',
    name: 'setting-company-round-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/company/roundingrule/form'),

  },
  {
    path: '/setting/company/round/edit/:id',
    name: 'setting-company-round-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/company/roundingrule/form'),
  },

  {
    path: '/setting/security/user',
    name: 'setting-security-user',
    meta: { authRequired: true },
    component: () => import('./views/settings/security/user/default'),
  },
  {
    path: '/setting/security/user/add',
    name: 'setting-security-user-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/security/user/form'),

  },
  {
    path: '/setting/security/user/edit/:id',
    name: 'setting-security-user-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/security/user/form'),
  },
  {
    path: '/setting/security/role',
    name: 'role',
    meta: { authRequired: true },
    component: () => import('./views/settings/security/role/default'),
  },
  {
    path: '/setting/security/role/edit/:id',
    name: 'role-edit',
    meta: { authRequired: true },
    component: () => import('./views/settings/security/role/form'),
  },
  {
    path: '/setting/security/role/add',
    name: 'role-add',
    meta: { authRequired: true },
    component: () => import('./views/settings/security/role/form'),
  },
  {
    path: '/general/customer',
    name: 'customer-list',
    meta: { authRequired: true },
    component: () => import('./views/customers/default'),
  },
  {
    path: '/general/customer/view/:id',
    name: 'customer-view',
    meta: { authRequired: true },
    component: () => import('./views/customers/view'),
  },
  {
    path: '/general/customer/add',
    name: 'customer-add',
    meta: { authRequired: true },
    component: () => import('./views/customers/form'),
  },
  {
    path: '/general/customer/edit/:id',
    name: 'customer-edit',
    meta: { authRequired: true },
    component: () => import('./views/customers/form'),
  },
  {
    path: '/general/customer/followup/:id',
    name: 'customer-followup',
    meta: { authRequired: true },
    component: () => import('./views/customers/followup'),
  },
  {
    path: '/general/seller',
    name: 'seller-list',
    meta: { authRequired: true },
    component: () => import('./views/sellers/default'),
  },
  {
    path: '/general/seller/staff',
    name: 'staff-list',
    meta: { authRequired: true },
    component: () => import('./views/sellers/staff'),
  },
  {
    path: '/general/seller/agency',
    name: 'agency-list',
    meta: { authRequired: true },
    component: () => import('./views/sellers/agency'),
  },
  {
    path: '/general/seller/mentor',
    name: 'mentor-list',
    meta: { authRequired: true },
    component: () => import('./views/sellers/mentor'),
  },
  {
    path: '/general/seller/view/:id',
    name: 'seller-view',
    meta: { authRequired: true },
    component: () => import('./views/sellers/view'),
  },
  {
    path: '/general/seller/add',
    name: 'seller-add',
    meta: { authRequired: true },
    component: () => import('./views/sellers/form'),
  },
  {
    path: '/general/seller/edit/:id',
    name: 'seller-edit',
    meta: { authRequired: true },
    component: () => import('./views/sellers/form'),
  },
  
  {
    path: '/general/cancelation',
    name: 'cancelation-list',
    meta: { authRequired: true },
    component: () => import('./views/properties/request-cancelation'),
  },
  {
    path: '/general/property',
    name: 'property-list',
    meta: { authRequired: true },
    component: () => import('./views/properties/default'),
  },
  {
    path: '/general/property/over-contract/:id',
    name: 'over-contract',
    meta: { authRequired: true },
    component: () => import('./views/document/over-contract'),
  },
  {
    path: '/general/property/view/:id',
    name: 'property-view',
    meta: { authRequired: true },
    component: () => import('./views/properties/view'),
  },
  {
    path: '/general/property/block/:id',
    name: 'property-block',
    meta: { authRequired: true },
    component: () => import('./views/properties/block'),
  },
  {
    path: '/general/property/book/:id',
    name: 'property-book-delay',
    meta: { authRequired: true },
    component: () => import('./views/properties/book-delay'),
  },
  {
    path: '/general/property/merge/:id',
    name: 'property-merge',
    meta: { authRequired: true },
    component: () => import('./views/properties/merge'),
  },
  {
    path: '/general/property/keep/:id',
    name: 'property-keep',
    meta: { authRequired: true },
    component: () => import('./views/properties/keep'),
  },
  {
    path: '/general/property/unkeep/:id',
    name: 'property-unkeep',
    meta: { authRequired: true },
    component: () => import('./views/properties/unkeep'),
  },
  {
    path: '/general/property/add',
    name: 'property-add',
    meta: { authRequired: true },
    component: () => import('./views/properties/form'),
  },
  {
    path: '/general/property/edit/:id',
    name: 'property-edit',
    meta: { authRequired: true },
    component: () => import('./views/properties/form'),
  },
  {
    path: '/general/property/update-price',
    name: 'property-update-price',
    meta: { authRequired: true },
    component: () => import('./views/properties/update-price'),
  },
  {
    path: '/general/property/contract/:id',
    name: 'property-contract',
    meta: { authRequired: true },
    component: () => import('./views/properties/contract'),
  },
  {
    path: '/general/property/contract/',
    name: 'property-contract-query',
    meta: { authRequired: true },
    component: () => import('./views/properties/contract'),
  },
  {
    path: '/general/property/cancelation/:id',
    name: 'property-cancelation',
    meta: { authRequired: true },
    component: () => import('./views/properties/cancelation'),
  },
  {
    path: '/general/property/cancelation/',
    name: 'property-cancelation-booking-sale',
    meta: { authRequired: true },
    component: () => import('./views/properties/cancelation'),
  },
  {
    path: '/general/property/handover/:id',
    name: 'property-handover',
    meta: { authRequired: true },
    component: () => import('./views/handover/handover'),
  },
  {
    path: '/general/properties/late-payment1/:local/:id',
    name: 'payment-schedule1',
    meta: { authRequired: true },
    component: () => import('./views/properties/late-payment1.vue'),
  },
  {
    path: '/general/properties/late-payment2/:local/:id',
    name: 'payment-schedule2',
    meta: { authRequired: true },
    component: () => import('./views/properties/late-payment2.vue'),
  },
  {
    path: '/general/properties/late-payment3/:local/:id',
    name: 'payment-schedule3',
    meta: { authRequired: true },
    component: () => import('./views/properties/late-payment3.vue'),
  },
  {
    path: '/general/properties/late-payment4/:local/:id',
    name: 'payment-schedule4',
    meta: { authRequired: true },
    component: () => import('./views/properties/late-payment4.vue'),
  },

  {
    path: '/contract/co-seller',
    name: 'co-seller-contract',
    meta: { authRequired: true },
    component: () => import('./views/contract/co_seller.vue'),
  },


  {
    path: '/general/properties/payment_schedule/:id',
    name: 'payment-schedule-sale',
    meta: { authRequired: true },
    component: () => import('./views/properties/payment_schedule'),
  },
  {
    path: '/general/properties/payment_schedule_en/:id',
    name: 'payment-schedule-en',
    meta: { authRequired: true },
    component: () => import('./views/properties/payment_schedule_en'),
  },
  {
    path: '/general/properties/payment_schedule',
    name: 'payment-schedule-all',
    meta: { authRequired: true },
    component: () => import('./views/properties/payment_schedule'),
  },

  {
    path: '/general/property/cancellation-contract/:id',
    name: 'property-cancellation-contract',
    meta: { authRequired: true },
    component: () => import('./views/properties/property-cancellation-contract'),
  },

  {
    path: '/general/booking',
    name: 'booking-list',
    meta: { authRequired: true },
    component: () => import('./views/bookings/default'),
  },
  {
    path: '/general/booking/view/:id',
    name: 'booking-view',
    meta: { authRequired: true },
    component: () => import('./views/bookings/view'),
  },
  {
    path: '/general/booking/receipt/:id',
    name: 'booking-receipt',
    meta: { authRequired: true },
    component: () => import('./views/bookings/multireceipt'),
  },
  {
    path: '/general/bookingpayment/receipt/:id',
    name: 'booking-payment-receipt',
    meta: { authRequired: true },
    component: () => import('./views/bookings/receiptpayment'),
  },
  {
    path: '/general/booking/extend/:id',
    name: 'booking-extend',
    meta: { authRequired: true },
    component: () => import('./views/bookings/extend'),
  },
  {
    path: '/general/booking/transfer/:id',
    name: 'booking-transfer',
    meta: { authRequired: true },
    component: () => import('./views/bookings/transfer'),
  },
  {
    path: '/general/booking/transfer',
    name: 'booking-transfer-property',
    meta: { authRequired: true },
    component: () => import('./views/bookings/transfer'),
  },

  {
    path: '/general/booking/add',
    name: 'booking-add',
    meta: { authRequired: true },
    component: () => import('./views/bookings/form'),
  },
  {
    path: '/general/booking/edit/:id',
    name: 'booking-edit',
    meta: { authRequired: true },
    component: () => import('./views/bookings/form'),
  },
  {
    path: '/general/sale',
    name: 'sale-list',
    meta: { authRequired: true },
    component: () => import('./views/sales/default'),
  },
  {
    path: '/general/sale/view/:id',
    name: 'sale-view',
    meta: { authRequired: true },
    component: () => import('./views/sales/view'),
  },
  {
    path: '/general/sales/change-term/:id',
    name: 'change-term',
    meta: { authRequired: true },
    component: () => import('./views/sales/change_term'),
  },
  {
    path: '/general/sales/late',
    name: 'sale-late',
    meta: { authRequired: true },
    component: () => import('./views/sales/late-log'),
  },
  {
    path: '/general/sales/change-term/schedule/:id',
    name: 'chang-schedule',
    meta: { authRequired: true },
    component: () => import('./views/sales/change_schedule'),
  },
  {
    path: '/general/sales/change-term/principal/:id',
    name: 'change-principal',
    meta: { authRequired: true },
    component: () => import('./views/sales/change_principal'),
  },
  {
    path: '/general/sales/payment/:id',
    name: 'payment',
    meta: { authRequired: true },
    component: () => import('./views/sales/payment'),
  },
  {
    path: '/general/sales/payment-list/:id',
    name: 'payment-list',
    meta: { authRequired: true },
    component: () => import('./views/sales/payment-list'),
  },
  {
    path: '/general/sales/receipt/:id',
    name: 'receipt',
    meta: { authRequired: true },
    component: () => import('./views/sales/receipt'),
  },
  {
    path: '/general/sales/change-term',
    name: 'change-term-all',
    meta: { authRequired: true },
    component: () => import('./views/sales/change_term'),
  },
  {
    path: '/general/sale/add',
    name: 'sale-add',
    meta: { authRequired: true },
    component: () => import('./views/sales/form'),
  },
  {
    path: '/general/sale/add/:bookingid',
    name: 'booking-sale-add',
    meta: { authRequired: true },
    component: () => import('./views/sales/form'),
  },
  {
    path: '/general/sale/edit/:id',
    name: 'sale-edit',
    meta: { authRequired: true },
    component: () => import('./views/sales/view'),
  },
  {
    path: '/general/sale/transferlist',
    name: 'sale-transfer-list',
    meta: { authRequired: true },
    component: () => import('./views/sales/transfer_default'),
  },
  {
    path: '/general/sale/transfer/:id',
    name: 'sale-transfer',
    meta: { authRequired: true },
    component: () => import('./views/sales/transfer'),
  },
  {
    path: '/general/sale/transfer',
    name: 'sale-transfer-property',
    meta: { authRequired: true },
    component: () => import('./views/sales/transfer'),
  },
  {
    path: '/general/sale/late-payment/:id',
    name: 'sale-late-payment',
    meta: { authRequired: true },
    component: () => import('./views/sales/late-payment'),
  },
  {
    path: '/general/sale/late-payment/:locale/:id',
    name: 'sale-late-payment-letter',
    meta: { authRequired: true },
    component: () => import('./views/sales/late-payment'),
  },
  {
    path: '/general/loan',
    name: 'loan-list',
    meta: { authRequired: true },
    component: () => import('./views/loans/default'),
  },
  {
    path: '/general/loan/view/:id',
    name: 'loan-view',
    meta: { authRequired: true },
    component: () => import('./views/loans/view'),
  },
  {
    path: '/general/loan/add',
    name: 'loan-add',
    meta: { authRequired: true },
    component: () => import('./views/loans/form'),
  },
  {
    path: '/general/loan/edit/:id',
    name: 'loan-edit',
    meta: { authRequired: true },
    component: () => import('./views/loans/form'),
  },
  // {
  //   path: '/general/payment',
  //   name: 'payment-list',
  //   meta: { authRequired: true },
  //   component: () => import('./views/payments/default'),
  // },
  {
    path: '/general/payment/receipt/:id',
    name: 'payment-receipt',
    meta: { authRequired: true },
    component: () => import('./views/payments/view'),
  },
  {
    path: '/general/payment/add',
    name: 'payment-add',
    meta: { authRequired: true },
    component: () => import('./views/payments/form'),
  },
  {
    path: '/general/payment/edit/:id',
    name: 'payment-edit',
    meta: { authRequired: true },
    component: () => import('./views/payments/form'),
  },
  {
    path: '/finance/account-balance',
    name: 'account-balance-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },

  

  {
    path: '/finance/income',
    name: 'income-list',
    meta: { authRequired: true },
    component: () => import('./views/finance/income/default'),
  },
  {
    path: '/finance/income/add',
    name: 'income-add',
    meta: { authRequired: true },
    component: () => import('./views/finance/income/form'),
  },
  {
    path: '/finance/income/:id',
    name: 'income-edit',
    meta: { authRequired: true },
    component: () => import('./views/finance/income/form'),
  },

  {
    path: '/finance/expense',
    name: 'expense-list',
    meta: { authRequired: true },
    component: () => import('./views/finance/expense/default'),
  },

  {
    path: '/finance/expense/add',
    name: 'expense-add',
    meta: { authRequired: true },
    component: () => import('./views/finance/expense/form'),
  },

  {
    path: '/finance/expense/:id',
    name: 'expense-edit',
    meta: { authRequired: true },
    component: () => import('./views/finance/expense/form'),
  },
  
  {
    path: '/expense/voucher',
    name: 'expense-voucher',
    meta: { authRequired: true },
    component: () => import('./views/expense/expense_voucher'),
  },
  {
    path: '/finance/history',
    name: 'history-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/finance/stock',
    name: 'stock-owner-list',
    meta: { authRequired: true },
    component: () => import('./views/stock-owner/default'),
  },
  {
    path: '/finance/stock/add',
    name: 'stock-owner-add',
    meta: { authRequired: true },
    component: () => import('./views/stock-owner/form'),
  },
  {
    path: '/finance/stock/edit/:id',
    name: 'stock-owner-edit',
    meta: { authRequired: true },
    component: () => import('./views/stock-owner/form'),
  },
  {
    path: '/finance/stock/approve/:id',
    name: 'stock-owner-approve',
    meta: { authRequired: true },
    component: () => import('./views/stock-owner/approve'),
  },
  {
    path: '/finance/stock/received/:id',
    name: 'stock-owner-received',
    meta: { authRequired: true },
    component: () => import('./views/stock-owner/received'),
  },
  {
    path: '/finance/stock/document/:id',
    name: 'stock-document',
    meta: { authRequired: true },
    component: () => import('./views/stock-owner/document'),
  },

  {
    path: '/finance/transfer-balance',
    name: 'transfer-balance-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/finance/adjust-balance',
    name: 'adjust-blance-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },

  // // ------- Need to Delete
  // {
  //   path: '/finance/journal',
  //   name: 'journal-list',
  //   meta: { authRequired: true },
  //   component: () => import('./views/finance/accountings/default'),
  // },
  // {
  //   path: '/finance/journal/add',
  //   name: 'journal-add',
  //   meta: { authRequired: true },
  //   component: () => import('./views/finance/accountings/form'),
  // },

  // //-------

  {
    path: '/additional/loan-calculator',
    name: 'loan-calculator-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/additional/view-map',
    name: 'view-map-list',
    meta: { authRequired: true },
    component: () => import('./views/projects/summary'),
  },
  // {
  //   path: '/additional/view-map-full',
  //   name: 'view-map-full',
  //   meta: { authRequired: true },
  //   component: () => import('./views/projects/summary'),
  // },
  {
    path: '/additional/property-master',
    name: 'property-master-list',
    meta: { authRequired: true },
    component: () => import('./views/properties/master'),
  },
  {
    path: '/additional/buy-back',
    name: 'buy-back-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/additional/sale-person',
    name: 'sale-person-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/additional/supplier',
    name: 'supplier-list',
    meta: { authRequired: true },
    component: () => import('./views/inventories/suppliers/default'),
  },
  {
    path: '/additional/supplier/add',
    name: 'supplier-add',
    meta: { authRequired: true },
    component: () => import('./views/inventories/suppliers/form'),
  },
  {
    path: '/additional/supplier/edit/:id',
    name: 'supplier-edit',
    meta: { authRequired: true },
    component: () => import('./views/inventories/suppliers/form'),
  },
  {
    path: '/additional/category',
    name: 'category-list',
    meta: { authRequired: true },
    component: () => import('./views/inventories/category/default'),
  },
  {
    path: '/additional/category/add',
    name: 'category-add',
    meta: { authRequired: true },
    component: () => import('./views/inventories/category/form'),
  },
  {
    path: '/additional/category/edit/:id',
    name: 'category-edit',
    meta: { authRequired: true },
    component: () => import('./views/inventories/category/form'),
  },
  {
    path: '/additional/item',
    name: 'item-list',
    meta: { authRequired: true },
    component: () => import('./views/inventories/item/default'),
  },
  {
    path: '/additional/item/add',
    name: 'item-add',
    meta: { authRequired: true },
    component: () => import('./views/inventories/item/form'),
  },
  {
    path: '/additional/item/edit/:id',
    name: 'item-edit',
    meta: { authRequired: true },
    component: () => import('./views/inventories/item/form'),
  },
  {
    path: '/additional/item/view/:id',
    name: 'item-view',
    meta: { authRequired: true },
    component: () => import('./views/inventories/invoice/view'),
  },
  {
    path: '/additional/invoice',
    name: 'invoice-list',
    meta: { authRequired: true },
    component: () => import('./views/inventories/invoice/default'),
  },
  {
    path: '/additional/invoice/add',
    name: 'invoice-add',
    meta: { authRequired: true },
    component: () => import('./views/inventories/invoice/form'),
  },
  {
    path: '/additional/invoice/edit/:id',
    name: 'invoice-edit',
    meta: { authRequired: true },
    component: () => import('./views/inventories/invoice/form'),
  },
  {
    path: '/additional/invoice/view/:id',
    name: 'invoice-view',
    meta: { authRequired: true },
    component: () => import('./views/inventories/invoice/view'),
  },
  {
    path: '/additional/invoice/request/:id',
    name: 'invoice-request',
    meta: { authRequired: true },
    component: () => import('./views/inventories/invoice/request'),
  },

  {
    path: '/additional/write-off',
    name: 'write-off-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/additional/return-deposit',
    name: 'return-deposit-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/additional/commission',
    name: 'commission-list',
    meta: { authRequired: true },
    component: () => import('./views/commissions/default'),
  },
  {
    path: '/additional/commission/print/:id',
    name: 'commission-print',
    meta: { authRequired: true },
    component: () => import('./views/commissions/receipt'),
  },
  {
    path: '/additional/commission/paid/:id',
    name: 'commission-paid',
    meta: { authRequired: true },
    component: () => import('./views/commissions/paid'),
  },
  {
    path: '/additional/commission/edit/:id',
    name: 'commission-edit',
    meta: { authRequired: true },
    component: () => import('./views/commissions/form'),
  },
  {
    path: '/additional/commission/view/:id',
    name: 'commission-view',
    meta: { authRequired: true },
    component: () => import('./views/commissions/view'),
  },
  {
    path: '/additional/handover',
    name: 'handover-list',
    meta: { authRequired: true },
    component: () => import('./views/handover/default'),
  },
  {
    path: '/additional/payoff-handover',
    name: 'payoff-handover-list',
    meta: { authRequired: true },
    component: () => import('./views/handoverpayoff/default'),
  },
  {
    path: '/additional/block-property',
    name: 'block-property-list',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default'),
  },

  {
    path: '/report',
    name: 'reports',
    meta: { authRequired: true },
    component: () => import('./views/reports/default'),
  },

  {
    path: '/report/project/summary',
    name: 'project-summary',
    meta: { authRequired: true },
    component: () => import('./views/projects/summary'),
  },
  {
    path: '/report/project/summary/:id',
    name: 'project-summary-id',
    meta: { authRequired: true },
    component: () => import('./views/projects/summary'),
  },
  

  // Income & Expense Report
  {
    path: '/report/pl/all',
    name: 'report-pl-all',
    meta: { authRequired: true },
    component: () => import('./views/reports/income_expense/default'),
  },

  {
    path: '/report/income/daily',
    name: 'report-income-daily',
    meta: { authRequired: true },
    component: () => import('./views/reports/income_expense/income_daily'),
  },

  {
    path: '/report/income/summary',
    name: 'report-income-summary',
    meta: { authRequired: true },
    component: () => import('./views/reports/income_expense/income_summary'),
  },

  {
    path: '/report/expense/daily',
    name: 'report-expense-daily',
    meta: { authRequired: true },
    component: () => import('./views/reports/income_expense/expense_daily'),
  },

  // sold report 
  {
    path: '/report/sale/detail',
    name: 'report-sale-detail',
    meta: { authRequired: true },
    component: () => import('./views/reports/sold_reports/sale_detail'),
  },

  {
    path: '/report/sale/unit',
    name: 'report-sale-unit',
    meta: { authRequired: true },
    component: () => import('./views/reports/sold_reports/sale_unit'),
  },
  // transfer sale 
  {
    path: '/report/transfer/sale',
    name: 'report-transfer-sale',
    meta: { authRequired: true },
    component: () => import('./views/reports/sold_reports/transfer_sale'),
  },

   // stage_sale_price_version
   {
    path: '/report/sale/price-version',
    name: 'report-sale-price-version',
    meta: { authRequired: true },
    component: () => import('./views/reports/sold_reports/stage_sale_price_version'),
  },

  // stage_sale_price_version
  {
    path: '/report/sale/all-price-version',
    name: 'report-all-sale-price-version',
    meta: { authRequired: true },
    component: () => import('./views/reports/sold_reports/sale_price_version'),
  },
    // transfer sale 
    {
      path: '/report/transfer-sale/print/:id',
      name: 'report-transfer-sale-print',
      meta: { authRequired: true },
      component: () => import('./views/reports/sold_reports/print'),
    },

  // payment 
  {
    path: '/report/item/stock',
    name: 'report-item-stock',
    meta: { authRequired: true },
    component: () => import('./views/reports/items/item_stock'),
  },
  {
    path: '/report/item/list',
    name: 'report-item-list',
    meta: { authRequired: true },
    component: () => import('./views/reports/items/item_list'),
  },
  {
    path: '/report/payment/detail',
    name: 'report-payment-detail',
    meta: { authRequired: true },
    component: () => import('./views/reports/payment_reports/payment_detail'),
  },
  {
    path: '/report/payment/principle',
    name: 'report-payment-principle',
    meta: { authRequired: true },
    component: () => import('./views/reports/payment_reports/principle'),
  },
  {
    path: '/report/payment/receive',
    name: 'report-payment-receive',
    meta: { authRequired: true },
    component: () => import('./views/reports/payment_reports/receive'),
  },
  {
    path: '/report/payment/collect',
    name: 'report-payment-collect',
    meta: { authRequired: true },
    component: () => import('./views/reports/payment_reports/collect_payment'),
  },
  {
    path: '/report/payment/late',
    name: 'report-payment-late',
    meta: { authRequired: true },
    component: () => import('./views/reports/payment_reports/payment_late'),
  },

  {
    path: '/report/payment/unit',
    name: 'report-payment-unit',
    meta: { authRequired: true },
    component: () => import('./views/reports/payment_reports/payment_unit'),
  },

  {
    path: '/report/payment/unit-detail',
    name: 'report-payment-unit-detail',
    meta: { authRequired: true },
    component: () => import('./views/reports/payment_reports/payment_unit_detail'),
  },

  // property report
  {
    path: '/report/property/group-summary',
    name: 'report-property-group-summary',
    meta: { authRequired: true },
    component: () => import('./views/reports/property_reports/group-summary'),
  },
  {
    path: '/report/property/cancelation',
    name: 'report-property-cancelation',
    meta: { authRequired: true },
    component: () => import('./views/reports/property_reports/cancelation'),
  },
  {
    path: '/report/property/detail',
    name: 'report-property-detail',
    meta: { authRequired: true },
    component: () => import('./views/reports/property_reports/detail'),
  },
  {
    path: '/report/property/price-changing',
    name: 'report-property-price-changing',
    meta: { authRequired: true },
    component: () => import('./views/reports/property_reports/price_changing'),
  },
  {
    path: '/report/daily/notification',
    name: 'report-daily-notification',
    meta: { authRequired: true },
    component: () => import('./views/reports/daily_reports/notification'),
  },

  {
    path: '/report/daily/customer-follow-up',
    name: 'report-daily-customer-follow-up',
    meta: { authRequired: true },
    component: () => import('./views/reports/daily_reports/follow_up'),
  },

  // booking 

  {
    path: '/report/booking/expired',
    name: 'report-booking-expired',
    meta: { authRequired: true },
    component: () => import('./views/reports/bookings/expired'),
  },

  {
    path: '/report/booking/daily',
    name: 'report-booking-daily',
    meta: { authRequired: true },
    component: () => import('./views/reports/bookings/daily'),
  },

  // Commission Report =======================================
  {
    path: '/report/commission/available',
    name: 'report-commission-available',
    meta: { authRequired: true },
    component: () => import('./views/reports/commission/available'),
  },

  {
    path: '/report/commission',
    name: 'report-commission',
    meta: { authRequired: true },
    component: () => import('./views/reports/commission/commission'),
  },

  {
    path: '/report/commission/staff',
    name: 'report-commission-staff',
    meta: { authRequired: true },
    component: () => import('./views/reports/commission/commission_staff'),
  },

  {
    path: '/report/commission/agency',
    name: 'report-commission-agency',
    meta: { authRequired: true },
    component: () => import('./views/reports/commission/commission_agency'),
  },

  {
    path: '/report/commission/indro',
    name: 'report-commission-indro',
    meta: { authRequired: true },
    component: () => import('./views/reports/commission/commission_indro'),
  },

  //=============== managements Room =========================
  {
    path: '/manage/login',
    name: 'manage-login',
    // meta: { authRequired: true },
    component: () => import('./views/account/login-manage')
  },
  {
    path: '/manage',
    name: 'manage',
    // meta: { authRequired: true },
    component: () => import('./views/managements/dashboards/default')
  },
  {
    path: '/manage/customer',
    name: 'manage-customer',
    meta: { authRequired: true },
    component: () => import('./views/managements/customers/default'),
  },
  {
    path: '/manage/customer/add',
    name: 'manage-customer-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/customers/form'),
  },
  {
    path: '/manage/customer/edit/:id',
    name: 'manage-customer-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/customers/form'),
  },

  {
    path: '/manage/customer/deposit/:id',
    name: 'manage-customer-deposit',
    meta: { authRequired: true },
    component: () => import('./views/managements/customers/deposit'),
  },

  {
    path: '/manage/property/view/:id',
    name: 'manage-property-view',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/view'),
  },

  {
    path: '/manage/property/open-credit/:id',
    name: 'manage-open-credit',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/open-credit'),
  },

  {
    path: '/manage/property',
    name: 'manage-property',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/default'),
  },
  {
    path: '/manage/property/setting/monthly-biling',
    name: 'manage-settting-property-monthly-biling',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/setting-monlthy-biling'),
  },
  {
    path: '/manage/property/setting/service',
    name: 'manage-setting-property-service',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/setting-service'),
  },
  
  {
    path: '/manage/property/setting/service/:id',
    name: 'manage-setting-property-service-id',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/setting-service'),
  },

  {
    path: '/manage/setting/penalty-setting',
    name: 'manage-setting-penalty-setting',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/penalty-setting/default'),
  },


  {
    path: '/manage/setting/penalty-setting/add',
    name: 'manage-setting-penalty-setting-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/penalty-setting/form'),
  },

  {
    path: '/manage/setting/penalty-setting/:id',
    name: 'manage-setting-penalty-setting-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/penalty-setting/form'),
  },

    {
    path: '/manage/setting/expense-category',
    name: 'manage-expense-category',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/expense-category/default'),
  },

  {
    path: '/manage/setting/expense-category/add',
    name: 'manage-expense-category-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/expense-category/form'),
  },

  {
    path: '/manage/setting/expense-category/edit/:id',
    name: 'manage-expense-category-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/expense-category/form'),
  },

  {
    path: '/manage/setting/income-category',
    name: 'manage-income-category',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/income-category/default'),
  },

  {
    path: '/manage/setting/income-category/add',
    name: 'manage-income-category-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/income-category/form'),
  },

  {
    path: '/manage/setting/income-category/edit/:id',
    name: 'manage-income-category-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/income-category/form'),
  },

  {
    path: '/manage/property/setting/monthly-biling/:id',
    name: 'manage-settting-property-monthly-biling-id',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/setting-monlthy-biling'),
  },

  {
    path: '/manage/property/utility/:id',
    name: 'manage-property-utility',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/utility-record'),
  },

  {
    path: '/manage/invoice/payment/:id',
    name: 'manage-invoice-payment',
    meta: { authRequired: true },
    component: () => import('./views/managements/payments/form'),
  },

  {
    path: '/manage/invoice/void/:id',
    name: 'manage-invoice-void',
    meta: { authRequired: true },
    component: () => import('./views/managements/invoices/void'),
  },

  {
    path: '/manage/property/rent/:id',
    name: 'manage-property-rent',
    meta: { authRequired: true },
    component: () => import('./views/managements/rents/rent'),
  },
  {
    path: '/manage/property/rent-approve/:id',
    name: 'manage-property-rent-approve',
    meta: { authRequired: true },
    component: () => import('./views/managements/rents/approve_rent'),
  },
  {
    path: '/manage/property/rent-contract/:id',
    name: 'manage-property-rent-contract',
    meta: { authRequired: true },
    component: () => import('./views/managements/rents/contract'),
  },

  {
    path: '/manage/property/rent/request-terminate/:id',
    name: 'manage-property-rent-request-terminate',
    meta: { authRequired: true },
    component: () => import('./views/managements/rents/request_terminate'),
  },
  {
    path: '/manage/property/rent/approve-terminate/:id',
    name: 'manage-property-rent-approve-terminate',
    meta: { authRequired: true },
    component: () => import('./views/managements/rents/approve_terminate'),
  },

  {
    path: '/manage/setting',
    name: 'manage-setting',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/default'),
  },

  {
    path: '/manage/setting/service',
    name: 'manage-setting-service',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/services/default'),
  },
  {
    path: '/manage/setting/service/add',
    name: 'manage-setting-service-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/services/form'),
  },
  {
    path: '/manage/setting/service/edit/:id',
    name: 'manage-setting-service-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/services/form'),
  },

  {
    path: '/manage/setting/service-type',
    name: 'manage-setting-service-type',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/service-types/default'),
  },
  {
    path: '/manage/setting/service-type/add',
    name: 'manage-setting-service-type-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/service-types/form'),
  },
  {
    path: '/manage/setting/service-type/edit/:id',
    name: 'manage-setting-service-type-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/service-types/form'),
  },
  {
    path: '/manage/setting/utility',
    name: 'manage-setting-utility',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/utilities/default'),
  },
  {
    path: '/manage/setting/utility/add',
    name: 'manage-setting-utility-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/utilities/form'),
  },
  {
    path: '/manage/setting/utility/edit/:id',
    name: 'manage-setting-utility-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/utilities/form'),
  },

  {
    path: '/manage/setting/deposit-type',
    name: 'manage-setting-deposit-type',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/deposit-types/default'),
  },

  {
    path: '/manage/setting/deposit-type/add',
    name: 'manage-setting-deposit-type-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/deposit-types/form'),
  },

  {
    path: '/manage/setting/deposit-type/edit:id',
    name: 'manage-setting-deposit-type-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/deposit-types/form'),
  },


  {
    path: '/manage/setting/room-status',
    name: 'manage-setting-room-status',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/room-statuses/default'),
  },

  {
    path: '/manage/setting/room-status/add',
    name: 'manage-setting-room-status-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/room-statuses/form'),
  },

  {
    path: '/manage/setting/room-status/edit:id',
    name: 'manage-setting-room-status-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/settings/room-statuses/form'),
  },

  {
    path: '/manage/invoice/generate/:id',
    name: 'manage-invoice-generate',
    meta: { authRequired: true },
    component: () => import('./views/managements/invoices/form'),
  },

  {
    path: '/manage/property/invoice/:id',
    name: 'manage-property-invoice',
    meta: { authRequired: true },
    component: () => import('./views/managements/invoices/default'),
  },

  {
    path: '/manage/property/invoice/print/:id',
    name: 'manage-invoice-print',
    meta: { authRequired: true },
    component: () => import('./views/managements/invoices/print'),
  },

  {
    path: '/manage/invoice',
    name: 'manage-invoice',
    meta: { authRequired: true },
    component: () => import('./views/managements/invoices/default'),
  },

  {
    path: '/manage/expense',
    name: 'manage-expense',
    meta: { authRequired: true },
    component: () => import('./views/managements/expenses/default'),
  },

  {
    path: '/manage/expense/add',
    name: 'manage-expense-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/expenses/form'),
  },

  {
    path: '/manage/expense/edit/:id',
    name: 'manage-expense-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/expenses/form'),
  },

  {
    path: '/manage/income',
    name: 'manage-income',
    meta: { authRequired: true },
    component: () => import('./views/managements/incomes/default'),
  },

  {
    path: '/manage/income/add',
    name: 'manage-income-add',
    meta: { authRequired: true },
    component: () => import('./views/managements/incomes/form'),
  },

  {
    path: '/manage/income/edit/:id',
    name: 'manage-income-edit',
    meta: { authRequired: true },
    component: () => import('./views/managements/incomes/form'),
  },

  {
    path: '/manage/keyover/',
    name: 'manage-keyover',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/keyover'),
  },
  {
    path: '/manage/keyover/detail/:id',
    name: 'manage-keyover-detail',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/keyover_detail'),
  },
  {
    path: '/manage/keyover/contract/:id',
    name: 'manage-keyover-contract',
    meta: { authRequired: true },
    component: () => import('./views/managements/properties/keyover_contract'),
  },
  // {
  //   path: '/manage/keyover/contract/:id',
  //   name: 'manage-keyover-contract',
  //   meta: { authRequired: true },
  //   component: () => import('./views/managements/properties/keyover'),
  // },




  //management report
  {
    path: '/manage/report',
    name: 'manage-report',
    meta: { authRequired: true },
    component: () => import('./views/managements/reports/default'),
  },

  {
    path: '/manage/report/service',
    name: 'manage-service-report',
    meta: { authRequired: true },
    component: () => import('./views/managements/reports/service'),
  },

  {
    path: '/manage/report/debt-amount-summary',
    name: 'manage-debt-amount-summary-report',
    meta: { authRequired: true },
    component: () => import('./views/managements/reports/debt_amount_summary'),
  },

  {
    path: '/manage/report/debt-amount',
    name: 'manage-debt-amount-report',
    meta: { authRequired: true },
    component: () => import('./views/managements/reports/debt_amount'),
  },

  {
    path: '/manage/report/income-expense',
    name: 'manage-income-expense-report',
    meta: { authRequired: true },
    component: () => import('./views/managements/reports/income_expense'),
  },




  //=============== Accounting =========================
  // {
  //   path: '/accounting/login',
  //   name: 'account-login',
  //   // meta: { authRequired: true },
  //   component: () => import('./views/account/login-accounting')
  // },
  // {
  //   path: '/accounting',
  //   name: 'account-home',
  //   // meta: { authRequired: true },
  //   component: () => import('./views/accountings/dashboards/default')
  // },
  // {
  //   path: '/accounting/type',
  //   name: 'account-type',
  //   meta: { authRequired: true },
  //   component: () => import('./views/accountings/accounttype/default'),
  // },
  // {
  //   path: '/accounting/type/add',
  //   name: 'account-type-add',
  //   meta: { authRequired: true },
  //   component: () => import('./views/accountings/accounttype/form'),
  // },
  // {
  //   path: '/accounting/type/edit/:id',
  //   name: 'account-type-edit',
  //   meta: { authRequired: true },
  //   component: () => import('./views/accountings/accounttype/form'),
  // },

  // {
  //   path: '/accounting/account',
  //   name: 'account-chart',
  //   meta: { authRequired: true },
  //   component: () => import('./views/accountings/account/default'),
  // },
  // {
  //   path: '/accounting/account/add',
  //   name: 'account-chart-add',
  //   meta: { authRequired: true },
  //   component: () => import('./views/accountings/account/form'),
  // },
  // {
  //   path: '/accounting/account/edit/:id',
  //   name: 'account-chart-edit',
  //   meta: { authRequired: true },
  //   component: () => import('./views/accountings/account/form'),
  // },

  // {
  //   path: '/accounting/journal',
  //   name: 'journal-list',
  //   meta: { authRequired: true },
  //   component: () => import('./views/accountings/journal/default'),
  // },
  // {
  //   path: '/accounting/journal/add',
  //   name: 'journal-add',
  //   meta: { authRequired: true },
  //   component: () => import('./views/accountings/journal/form'),
  // },
  // {
  //   path: '/accounting/journal/edit/:id',
  //   name: 'journal-edit',
  //   meta: { authRequired: true },
  //   component: () => import('./views/accountings/journal/form'),
  // },
  // {
  //   path: '/accounting/report/journal',
  //   name: 'report-accounting-journal',
  //   meta: { authRequired: true },
  //   component: () => import('./views/reports/accounting/journal'),
  // },
  // {
  //   path: '/accounting/report/leadger',
  //   name: 'report-accounting-leadger',
  //   meta: { authRequired: true },
  //   component: () => import('./views/reports/accounting/leadger'),
  // },

  // {
  //   path: '/accounting/report/trial',
  //   name: 'report-accounting-trial',
  //   meta: { authRequired: true },
  //   component: () => import('./views/reports/accounting/trial'),
  // },
  // {
  //   path: '/accounting/report/pnl',
  //   name: 'report-accounting-pnl',
  //   meta: { authRequired: true },
  //   component: () => import('./views/reports/accounting/pnl'),
  // },
  // {
  //   path: '/accounting/report/balance-sheet',
  //   name: 'report-accounting-balancesheet',
  //   meta: { authRequired: true },
  //   component: () => import('./views/reports/accounting/balancesheet'),
  // },
  // {
  //   path: '/accounting/report/cash-flow',
  //   name: 'report-accounting-cashflow',
  //   meta: { authRequired: true },
  //   component: () => import('./views/reports/accounting/cashflow'),
  // },

]